'use strict';

var Util = require("../layouts/util.js");
var React = require("react");
var Button = require("./button.js");
var ReasonReact = require("reason-react/src/ReasonReact.js");
var SubscribeFormModuleScss = require("./subscribeForm.module.scss");

var component = ReasonReact.statelessComponent("SubscribeForm");

function make() {
  return /* record */[
          /* debugName */component[/* debugName */0],
          /* reactClassInternal */component[/* reactClassInternal */1],
          /* handedOffState */component[/* handedOffState */2],
          /* willReceiveProps */component[/* willReceiveProps */3],
          /* didMount */component[/* didMount */4],
          /* didUpdate */component[/* didUpdate */5],
          /* willUnmount */component[/* willUnmount */6],
          /* willUpdate */component[/* willUpdate */7],
          /* shouldUpdate */component[/* shouldUpdate */8],
          /* render */(function () {
              return React.cloneElement(React.createElement("form", {
                              className: SubscribeFormModuleScss.root,
                              id: "mc-embedded-subscribe-form",
                              action: "https://reason-conf.us17.list-manage.com/subscribe/post?u=2ff99718c52457a4fa5219f66&amp;id=3e392893b9",
                              method: "post",
                              name: "mc-embedded-subscribe-form",
                              target: "_blank"
                            }, React.createElement("p", {
                                  className: SubscribeFormModuleScss.text
                                }, Util.s("Get ReasonConf news straight to your inbox.")), React.createElement("p", {
                                  className: SubscribeFormModuleScss.smallText
                                }, Util.md("We use MailChimp as newsletter tool. By subscribing you acknowledge that the information\n                you provide will be transferred to MailChimp for processing in accordance with their\n                [Privacy Policy](https://mailchimp.com/legal/privacy/) and [Terms](https://mailchimp.com/legal/terms/).\n            ")), React.createElement("div", {
                                  className: SubscribeFormModuleScss.formRow
                                }, React.createElement("label", {
                                      className: SubscribeFormModuleScss.label,
                                      htmlFor: "email"
                                    }, Util.s("Email")), React.createElement("input", {
                                      className: SubscribeFormModuleScss.input,
                                      id: "mce-EMAIL",
                                      name: "EMAIL",
                                      placeholder: "name@domain.com",
                                      required: true,
                                      type: "email"
                                    }), React.createElement("div", {
                                      className: SubscribeFormModuleScss.hiddenInput
                                    }, React.createElement("input", {
                                          tabIndex: -1,
                                          name: "b_2ff99718c52457a4fa5219f66_3e392893b9",
                                          type: "text"
                                        })), ReasonReact.element(/* None */0, /* None */0, Button.make("submit", /* None */0, /* array */[Util.s("Subscribe")]))), React.createElement("input", {
                                  name: "form-name",
                                  type: "hidden",
                                  value: "newsletter"
                                })), {
                          "data-netlify": true
                        });
            }),
          /* initialState */component[/* initialState */10],
          /* retainedProps */component[/* retainedProps */11],
          /* reducer */component[/* reducer */12],
          /* subscriptions */component[/* subscriptions */13],
          /* jsElementWrapped */component[/* jsElementWrapped */14]
        ];
}

var Link = 0;

exports.Link = Link;
exports.component = component;
exports.make = make;
/* component Not a pure module */



// WEBPACK FOOTER //
// ./src/components/subscribeForm.js